export const SET_ACTIVE = 'SET_ACTIVE';
export const VOLUME_DAILY = 'VOLUME_DAILY'
export const STAKING_DAILY = 'STAKING_DAILY'
export const AUM_DAILY = 'AUM_DAILY'
export const FEE_DAILY = 'FEE_DAILY'
export const PNL_DAILY = 'PNL_DAILY'
export const YLP_DAILY = 'YLP_DAILY'
export const YLP_PRICEDAILY = 'YLP_PRICEDAILY'
export const YORROWING_DAILY = 'YORROWING_DAILY'
export const MARKETS = 'MARKETS'

export const VOLUME_DAILY_MARKETS_DEFAULT = 'VOLUME_DAILY_MARKETS_DEFAULT'
export const STAKING_DAILY_MARKETS_DEFAULT = 'STAKING_DAILY_MARKETS_DEFAULT'
export const AUM_DAILY_MARKETS_DEFAULT = 'AUM_DAILY_MARKETS_DEFAULT'
export const FEE_DAILY_MARKETS_DEFAULT = 'FEE_DAILY_MARKETS_DEFAULT'
export const PNL_DAILY_MARKETS_DEFAULT = 'PNL_DAILY_MARKETS_DEFAULT'
export const YLP_DAILY_MARKETS_DEFAULT = 'YLP_DAILY_MARKETS_DEFAULT'
export const YLP_PRICEDAILY_MARKETS_DEFAULT = 'YLP_PRICEDAILY_MARKETS_DEFAULT'
export const YORROWING_DAILY_MARKETS_DEFAULT = 'YORROWING_DAILY_MARKETS_DEFAULT'